"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABEL_PPA = exports.LABEL_DEAL = exports.LABEL_CAN_BE_SUBSCRIBED = exports.LABEL_CAN_BE_RESERVED = exports.LABEL_ADD_TO_BASKET_VISIBLE = void 0;
const LABEL_ADD_TO_BASKET_VISIBLE = exports.LABEL_ADD_TO_BASKET_VISIBLE = 'AddToBasketVisible';
const LABEL_CAN_BE_RESERVED = exports.LABEL_CAN_BE_RESERVED = 'CanBeReserved';
const LABEL_CAN_BE_SUBSCRIBED = exports.LABEL_CAN_BE_SUBSCRIBED = 'CanBeSubscribed';
const LABEL_DEAL = exports.LABEL_DEAL = 'Deal';
const LABEL_PPA = exports.LABEL_PPA = 'PPA';
